/**
 * Application configuration settings with support for custom overrides via Stencil blocks.
 */
export const appConfig = Object.assign(
    {
        useDefaultLayout: true,
    },
    {
        // Override any configs here
        // <<Stencil::Block(appConfig)>>
        useDefaultLayout: false,
        // <</Stencil::Block>>
    },
);
